import { gql } from '@apollo/client'

const FIND_DUPLICATE_USERS = gql`
  query findDuplicateUsers($emails: [String!]!, $nonprofitOrgId: Int!) {
    findDuplicateUsers(emails: $emails, nonprofitOrgId: $nonprofitOrgId) {
      emails
    }
  }
`

export default FIND_DUPLICATE_USERS
